const SYMBOLS = {
  ZAR: "R", USD: "$", EUR: "€", GBP: "£", AUD: "A$", CAD: "C$", NZD: "NZ$",
  JPY: "¥", CNY: "¥", INR: "₹", NGN: "₦", KES: "KSh", GHS: "₵", UGX: "USh",
  TZS: "TSh", ZMW: "ZK", BWP: "P", NAD: "N$", MWK: "MK", MZN: "MT", MUR: "₨",
  EGP: "E£", MAD: "DH", NOK: "kr", SEK: "kr", DKK: "kr", ISK: "kr", CHF: "CHF ",
  PLN: "zł", CZK: "Kč", HUF: "Ft", RON: "lei", BGN: "лв", RUB: "₽", UAH: "₴",
  TRY: "₺", ILS: "₪", SAR: "﷼", AED: "د.إ ", QAR: "﷼", KWD: "د.ك ", BHD: ".د.ب ",
  OMR: "﷼", JOD: "د.ا ", LBP: "ل.ل ", PKR: "₨", BDT: "৳", LKR: "රු", NPR: "₨",
  THB: "฿", VND: "₫", KRW: "₩", PHP: "₱", IDR: "Rp", MYR: "RM", SGD: "S$",
  HKD: "HK$", TWD: "NT$", BRL: "R$", MXN: "Mex$", ARS: "$", CLP: "$", COP: "$",
  PEN: "S/", UYU: "$U", BOB: "Bs", PYG: "₲", CRC: "₡", GTQ: "Q", DOP: "RD$",
  JMD: "J$", TTD: "TT$", BBD: "Bds$", BSD: "B$", XCD: "EC$", KZT: "₸", GEL: "₾",
  AZN: "₼", AMD: "֏", KGS: "с", UZS: "so'm", MNT: "₮", MMK: "K", KHR: "៛",
  LAK: "₭", AFN: "؋", IRR: "﷼", IQD: "ع.د ", DZD: "دج ", TND: "د.ت ", LYD: "ل.د ",
  ETB: "Br", XOF: "CFA", XAF: "FCFA", CDF: "FC", RWF: "FRw", AOA: "Kz",
};

export function currencySymbol(code = "ZAR") {
  if (SYMBOLS[code]) return SYMBOLS[code];
  return code ? `${code} ` : "R";
}

export function money(value, code = "ZAR", opts = {}) {
  const n = Number(value || 0);
  const sym = currencySymbol(code);
  const decimals = opts.decimals ?? (Math.abs(n) >= 1000 || Number.isInteger(n) ? 0 : 2);
  const formatted = n.toLocaleString("en-ZA", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return `${sym}${formatted}`;
}

export function shortDate(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("en-ZA", { day: "numeric", month: "short" });
  } catch {
    return d;
  }
}

export function longDate(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("en-ZA", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return d;
  }
}

export function dmy(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("en-ZA", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return d;
  }
}

export function monthLabel(d = new Date()) {
  return d.toLocaleDateString("en-ZA", { month: "long", year: "numeric" });
}

export function monthShort(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("en-ZA", { month: "short", year: "numeric" });
  } catch {
    return "";
  }
}
